import { useAppSelector } from 'store/store';
import { BottomFromDirectorRoles } from 'shared/permissions/roles';

export function IsBottomFromDirector({ children }) {
  const groups = useAppSelector((state) => state.auth.groups);
  if (groups?.some((role) => BottomFromDirectorRoles.includes(role))) return children;
}
